import { Boundaries } from "@planzone/core";
import { id, projectCreationError, zone } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  error: projectCreationError,
  hasProjectToCreateInZone: false,
  zoneToCreateProject: { ...zone, uuid: id },
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isSuccessful: true },
    hasProjectToCreateInZone: false,
  };
}

function handleFailure(
  state: State,
  { error }: Boundaries["createProject"]["failure"],
): State {
  return {
    ...state,
    error,
    request: { ...initialState.request, isFailure: true },
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createProjectRequested]: handleRequest,
    [events.createProjectSucceeded]: handleSuccess,
    [events.createProjectFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
